import {Erro} from "./Erro";

export class ResultadoEnvioAditivo {
  idePac: number;
  ideAditivo: number;
  idePacAlterada: number;
  erros: Erro[];
}
